<template>
  <div>
    <template v-if="show">
      <b-sidebar
        id="sidebar-right"
        :title="obj.title"
        backdrop
        shadow
        v-model="showSidebar"
        @change="visibleChanged"
        width="70vw"
        scrollable
      >
        <div class="bg-white">
          <ul class="list-group tx-13">
            <li
              v-for="(u, i) in users"
              :key="i"
              class="list-group-item list-group-item-action d-flex pd-x-20"
            >
              <div class="avatar">
                <img :src="u.avator" class="rounded-circle" alt />
              </div>
              <div class="pd-l-10">
                <p class="tx-medium mg-b-0">{{ u.displayName }}</p>
                <small class="tx-12 tx-color-03 mg-b-0">{{ u.position }}</small>
              </div>
              <div class="mg-l-auto d-flex align-self-center">
                <nav class="nav nav-icon-only" v-if="module == 'project'">
                  <a
                    @click="changePer(5, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isAdmin ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Админ
                  </a>
                  <a
                    @click="changePer(100, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isList ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Жагсаалт харах
                  </a>
                  <a
                    @click="changePer(6, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isNew ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Үүсгэх
                  </a>
                  <a
                    @click="changePer(1, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isWrite ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Засах
                  </a>
                  <a
                    @click="changePer(2, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isDelete ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Устгах
                  </a>
                  <a
                    @click="changePer(3, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isShare ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Хуваалцах
                  </a>
                </nav>
                <nav class="nav nav-icon-only" v-else-if="module == 'task'">
                  <a
                    @click="changePer(1, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isWrite ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Засах
                  </a>
                  <a
                    @click="changePer(2, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isDelete ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Устгах
                  </a>
                  <a
                    @click="changePer(3, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isShare ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Хуваалцах
                  </a>
                </nav>
                <nav class="nav nav-icon-only" v-else-if="module == 'form'">
                  <a
                    @click="changePer(1, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isEdit ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Засах
                  </a>
                  <a
                    @click="changePer(25, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isReport ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Тайлан
                  </a>
                </nav>
                <nav class="nav nav-icon-only" v-else-if="module == 'file'">
                  <a
                    @click="changePer(1, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isWrite ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Засах
                  </a>
                  <a
                    @click="changePer(2, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isDelete ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Устгах
                  </a>
                  <a
                    @click="changePer(3, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isShare ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Хуваалцах
                  </a>
                  <a
                    @click="changePer(200, u.userId)"
                    role="button"
                    class="nav-link d-none d-sm-block"
                  >
                    <b-icon
                      :icon="u.isDownload ? 'check-square' : 'square'"
                      class="mg-r-5"
                    ></b-icon
                    >Татах
                  </a>
                </nav>
              </div>
            </li>
          </ul>
        </div>
        <template v-slot:footer>
          <div class="bd-t text-center pd-y-7">
            <a @click="$emit('on-share')" class="btn btn-xs btn-light"
              >Хуваалцах</a
            >
          </div>
        </template>
      </b-sidebar>
    </template>
  </div>
</template>

<script>
import {
  getProjectUsers,
  postProjectPermissionIsWrite,
  postProjectPermissionIsNew,
  postProjectPermissionIsDelete,
  postProjectPermissionIsShare,
  postProjectPermissionIsAdmin,
  postProjectPermissionIsList
} from "@/api/user/projectInUser";

import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { Message } from "element-ui";

export default {
  name: "projectUsers",
  data: () => ({
    showSidebar: false,
    users: [],
    fetched: false
  }),
  props: {
    obj: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: () => false
    },
    module: {
      type: String,
      default: () => ""
    }
  },
  watch: {
    show: function(newVal) {
      if (newVal) {
        this.canSettings();
      }
    }
  },
  mounted() {},
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    canSettings() {
      //console.log('this.module', this.module);
      switch (this.module) {
        case "project": {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "Project/PreShare" },
            params: { projectId: this.obj.id },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.init();
            } else {
              this.visibleChanged(false);
            }
          });

          break;
        }
        case "task":{
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "Task/PreShare" },
            params: { id: this.obj.id },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.init();
            } else {
              this.visibleChanged(false);
            }
          });
          break;
        }
        case "file":{
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "Media/FilePreShare" },
            params: { id: this.obj.id },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.init();
            } else {
              this.visibleChanged(false);
            }
          });
          break;
        }
        default: {
          this.init();
          break;
        }
      }
    },
    init() {
      this.showSidebar = true;
      switch (this.module) {
        case "project": {
          getProjectUsers({
            params: { projectId: this.obj.id, page: 0, size: 5000 },
            store: this.$store
          }).then(res => {
            if (res != false) {
              //console.log(res.data.users);
              this.users = res.data.users;
              this.fetched = true;

              this.$nextTick(function() {
                window.addEventListener("resize", this.getWindowHeight);
                this.getWindowHeight();
              });
            } else {
              this.fetched = false;
              this.visibleChanged(false);
            }
          });
          break;
        }
        case "task": {
          //console.log('task users frd');
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "TaskInUser/GetInheritedList" },
            params: { 
              taskId: this.obj.id ,
              page: 0,
              size: 5000
            },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.users = res.data.users;
              this.fetched = true;

              this.$nextTick(function() {
                window.addEventListener("resize", this.getWindowHeight);
                this.getWindowHeight();
              });
            } else {
              this.fetched = false;
              this.visibleChanged(false);
            }
          });
          break;
        }
        case "form": {
          request({
            api: { method: "get", url: "FormInUser/GetInheritedList" },
            params: {
              formId: this.obj.id,
              page: 0,
              size: 5000
            },
            store: this.$store
          }).then(res => {
            if (res != false) {
              this.fetched = true;
              this.users = res.data.users;
              this.$nextTick(function() {
                window.addEventListener("resize", this.getWindowHeight);
                this.getWindowHeight();
              });
            } else {
              this.fetched = false;
              this.visibleChanged(false);
            }
          });

          break;
        }
        case "file": {
          request({
            api: { method: "GET", url: "Media/GetFileSharedUserList" },
            params: {
              id: this.obj.id,
              page: 0,
              size: 5000
            },
            store: this.$store
          }).then(res => {
            if (res != false) {
              this.fetched = true;
              this.users = res.data.users;
              this.$nextTick(function() {
                window.addEventListener("resize", this.getWindowHeight);
                this.getWindowHeight();
              });
            } else {
              this.fetched = false;
              this.visibleChanged(false);
            }
          });

          break;
        }
        default: {
          break;
        }
      }
    },
    getWindowHeight() {},
    changePer(mode, uid) {
      //console.log(mode, uid);
      switch (mode) {
        case 1: //# Засах
        {
          switch (this.module) {
            case "project": {
              postProjectPermissionIsWrite({
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) this.init();
              });
              break;
            }
            case "task":{
              request({
                api: { method: "post", url: "TaskInUser/PostTaskPermissionIsWrite" },
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  if (res != false) {
                    this.init();
                    Message({ message: "Амжилттай хадгаллаа.", type: "success" });
                  }
                }
              });
              break;
            }
            case "form": {
              request({
                api: {
                  method: "post",
                  url: "FormInUser/PostFormPermissionIsEdit"
                },
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  if (res != false) {
                    this.init();
                    Message({
                      message: "Амжилттай хадгаллаа.",
                      type: "success"
                    });
                  }
                }
              });

              break;
            }
            case "file":{
              request({
                api: { method: "POST", url: "Media/PostFilePermissionIsWrite" },
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  if (res != false) {
                    this.init();
                    Message({
                      message: "Амжилттай хадгаллаа.",
                      type: "success"
                    });
                  }
                }
              });
              break;
            }
          }

          break;
        }
        case 2: //# Устгах
          switch (this.module) {
            case "project":
              postProjectPermissionIsDelete({
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) this.init();
              });
              break;
            
            case "task":{
              request({
                api: { method: "post", url: "TaskInUser/PostTaskPermissionIsDelete" },
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  if (res != false) {
                    this.init();
                    Message({ message: "Амжилттай хадгаллаа.", type: "success" });
                  }
                }
              });
              break;
            }
            case "file":{
              request({
                api: { method: "POST", url: "Media/PostFilePermissionIsDelete" },
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  if (res != false) {
                    this.init();
                    Message({
                      message: "Амжилттай хадгаллаа.",
                      type: "success"
                    });
                  }
                }
              });
              break;
            }

            default: break;
          }

          break;
        case 3: //# Хуваалцах
          switch (this.module) {
            case "project":{
              postProjectPermissionIsShare({
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) this.init();
              });
              break;
            }
            case "task":{
              request({
                api: { method: "post", url: "TaskInUser/PostTaskPermissionIsShare" },
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  if (res != false) {
                    this.init();
                    Message({ message: "Амжилттай хадгаллаа.", type: "success" });
                  }
                }
              });
              break;
            }
            case "file":{
              request({
                api: { method: "POST", url: "Media/PostFilePermissionIsShare" },
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  if (res != false) {
                    this.init();
                    Message({
                      message: "Амжилттай хадгаллаа.",
                      type: "success"
                    });
                  }
                }
              });
              break;
            }
            default: break;
          }
          break;
        case 5: //# Админ
          switch (this.module) {
            case "project":
              postProjectPermissionIsAdmin({
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) this.init();
              });
              break;
          }
          break;
        case 6: //# Шинэ
          switch (this.module) {
            case "project":
              postProjectPermissionIsNew({
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) this.init();
              });
              break;
          }
          break;
        case 100: //# Жагсаалт харах
          switch (this.module) {
            case "project":
              postProjectPermissionIsList({
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) this.init();
              });
              break;
          }
          break;
        case 200: //# file tatah
        {
          request({
                api: { method: "POST", url: "Media/PostFilePermissionIsDownload" },
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  Message({
                    message: "Амжилттай хадгаллаа.",
                    type: "success"
                  });
                  this.init();
                }
              });
          break;
        }
        case 25: {
          switch (this.module) {
            case "form": {
              request({
                api: {
                  method: "post",
                  url: "FormInUser/PostFormPermissionIsReport"
                },
                data: { id: this.obj.id, userId: uid },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  if (res != false) {
                    Message({
                      message: "Амжилттай хадгаллаа.",
                      type: "success"
                    });
                    this.init();
                  }
                }
              });

              break;
            }
          }

          break;
        }
      }
    },
    visibleChanged(e) {
      if (!e) {
        this.$emit("on-edit-close");
      }
    }
  }
};
</script>
